<template>
  <ul class="space-y-4">
    <li
      v-for="customerIssue in props.customerIssues"
      :key="customerIssue.id"
      class="body-2"
    >
      {{ customerIssue.label }}
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { CustomerIssue } from '~/api/seller-after-sales/types'

const props = defineProps<{ customerIssues: CustomerIssue[] }>()
</script>
